export default __webpack_public_path__ + "static/media/logo_eurocity.e02af519.svg";